import Vue from 'vue'
import VueRouter from 'vue-router'
import AuthGuard from './authgaurd'
import Home from '../views/Home.vue'
import Store from '@/store'
const Rules = () => import('@/views/Rules')
const MyPicks = () => import('@/views/MyPicks')
const Leaders = () => import('@/views/Leaders')
const MakeEntry = () => import('@/views/MakeEntry')
const Admin = () => import('@/views/Admin')
const Login = () => import('@/views/user/Login')
const Register = () => import('@/views/user/Register')
const Forgot = () => import('@/views/user/Forgot')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/rules',
    name: 'Rules',
    component: Rules,
  },
  {
    path: '/mypicks',
    name: 'MyPicks',
    component: MyPicks,
  },
  {
    path: '/leaders',
    name: 'Leaders',
    component: Leaders,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
  },
  {
    path: '/forgot',
    name: 'Forgot',
    component: Forgot,
  },
  {
    path: '/makeentry/:uid?/:timestamp?',
    name: 'MakeEntry',
    component: MakeEntry,
    beforeEnter: AuthGuard
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    beforeEnter: (to, from, next) => {
      if (Store.getters.user && Store.getters.user.admin) {
        next()
      } else {
        next('/')
      }
    }
  },
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
